import { render } from "./sidebar-filters.vue?vue&type=template&id=88cc2994&scoped=true"
import script from "./sidebar-filters.vue?vue&type=script&lang=js"
export * from "./sidebar-filters.vue?vue&type=script&lang=js"

import "./sidebar-filters.vue?vue&type=style&index=0&id=88cc2994&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88cc2994"],['__file',"src/components/calendar/page-calendar/sidebar-filters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88cc2994"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88cc2994', __exports__)) {
    api.reload('88cc2994', __exports__)
  }
  
  module.hot.accept("./sidebar-filters.vue?vue&type=template&id=88cc2994&scoped=true", () => {
    api.rerender('88cc2994', render)
  })

}


export default __exports__